import logger from 'Logger';
import config from 'Config';
import { fetchFeatureFlippingKeys } from 'Utils/feature-flipping/featureFlipping.query';
export async function fetchFeatureFlippingKeysFromCms(
  appContext: AppContext,
): Promise<CMSFeatureFlips> {
  if (!config.get('cms.enableFeatureFlippingFromCms')) {
    return null;
  }

  try {
    const keys = await fetchFeatureFlippingKeys(appContext);
    return keys;
  } catch (error) {
    logger.error(error);
    return null;
  }
}
